import { render, staticRenderFns } from "./SlackSettings.vue?vue&type=template&id=6d10c28a&scoped=true"
import script from "./SlackSettings.vue?vue&type=script&lang=js"
export * from "./SlackSettings.vue?vue&type=script&lang=js"
import style0 from "./SlackSettings.vue?vue&type=style&index=0&id=6d10c28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10c28a",
  null
  
)

export default component.exports